import FloatingActions from './FloatingActions.component';

export default FloatingActions;
